import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const GasLimitPropsSchema = z.object({
  gasLimitValue: z.instanceof(HexNumber),
})

export type GasLimitProps = z.infer<typeof GasLimitPropsSchema>

export class GasLimit extends ValueObject<GasLimitProps> {
  /**
   * @returns A 0x-prefixed hex string.
   */
  public getHexValue(): string {
    return this.props.gasLimitValue.getValue()
  }

  public static create(gasLimitValue: HexNumber): GasLimit {
    const validatedProps = GasLimitPropsSchema.parse({ gasLimitValue })
    return new GasLimit(validatedProps)
  }
}
